import axios from "axios";

export function getEnabledCourses(ondemandId) {
  const URL = `${process.env.REACT_APP_REPO}/v1/repo_aden/ondemand/get_routes/${ondemandId}`;
  return axios.get(URL);
  
}
